import { ActionType } from '../../types/action';

// Treasury permissions — the madkhol-admin `treasury-*` resources
const readTreasuryPermission = {
  resource: 'treasury-thrift-companies',
  action: ActionType.READ,
};

const updateTreasuryPermission = {
  resource: 'treasury-thrift-companies',
  action: ActionType.UPDATE,
};

// The treasury employee's personal email (update) and approve (create)
const updateTreasuryUserEmployeePermission = {
  resource: 'treasury-user-employee',
  action: ActionType.UPDATE,
};

const createTreasuryUserEmployeePermission = {
  resource: 'treasury-user-employee',
  action: ActionType.CREATE,
};

// The company KYB (save, verify and agreements are update; the read, readiness and progress are read)
const readTreasuryKybPermission = {
  resource: 'treasury-thrift-company-kyb',
  action: ActionType.READ,
};

const updateTreasuryKybPermission = {
  resource: 'treasury-thrift-company-kyb',
  action: ActionType.UPDATE,
};

// The operations once the company Alpaca account is ACTIVE — one madkhol-admin resource each
const permission = (resource: string, action: ActionType) => ({ resource, action });

export const Treasury = {
  readKyb: readTreasuryKybPermission,
  updateKyb: updateTreasuryKybPermission,
  read: readTreasuryPermission,
  update: updateTreasuryPermission,
  updateEmployee: updateTreasuryUserEmployeePermission,
  approveEmployee: createTreasuryUserEmployeePermission,
  readContributions: permission('treasury-thrift-company-contributions', ActionType.READ),
  createContribution: permission('treasury-thrift-company-contributions', ActionType.CREATE),
  executeContribution: permission('treasury-thrift-company-contributions', ActionType.UPDATE),
  createRedemption: permission('treasury-thrift-company-redemptions', ActionType.CREATE),
  readRedeemRules: permission('treasury-thrift-company-redeem-automations', ActionType.READ),
  createRedeemRule: permission('treasury-thrift-company-redeem-automations', ActionType.CREATE),
  updateRedeemRule: permission('treasury-thrift-company-redeem-automations', ActionType.UPDATE),
  deleteRedeemRule: permission('treasury-thrift-company-redeem-automations', ActionType.DELETE),
  readWithdrawals: permission('treasury-thrift-company-withdraw-requests', ActionType.READ),
  createWithdrawal: permission('treasury-thrift-company-withdraw-requests', ActionType.CREATE),
  updateWithdrawal: permission('treasury-thrift-company-withdraw-requests', ActionType.UPDATE),
};
